import { createFileRoute } from "@tanstack/react-router";
import ActivityLogPage from "@/pages/ActivityLogPage";

export const Route = createFileRoute("/_app/settings/activity-log")({
  component: ActivityLogPage,
});
